module.exports = __webpack_public_path__ + "static/media/facebook_share_icon.4c32fd6e.png";